import { z } from 'zod'
import {
  productTypeNameSchema,
  productTypeSchema,
  supplierCodeSchema,
  supplierNamesSchema
} from '@/modules/sales/clients/types/articleTypes/Common.ts'

export const supplierSchema = z.object({
  id: z.string(),
  name: supplierNamesSchema,
  code: supplierCodeSchema,
  productTypeId: productTypeSchema,
  productTypeName: productTypeNameSchema
})

export type Supplier = z.infer<typeof supplierSchema>
